// @file Append custom stylesheet to document head with javascript

interface HTMLStyleElementWrapper {
  style: HTMLStyleElement
  remove: () => void
  update: (updatedCssString: string) => void
}

const appendedCss = new Map<string, HTMLStyleElementWrapper>()

/**
 * Append custom stylesheet to document head.
 * Duplicate stylesheets are not appended.
 */
function appendCssToDocumentHead(cssString: string): HTMLStyleElementWrapper {
  if (appendedCss.has(cssString)) {
    return appendedCss.get(cssString) as HTMLStyleElementWrapper
  }
  const styleTag = document.createElement('style')
  styleTag.innerHTML = cssString
  document.head.appendChild(styleTag)
  const customStyle = {
    style: styleTag,
    remove() {
      styleTag.remove()
      appendedCss.delete(cssString)
    },
    update(updatedCssString: string) {
      appendedCss.delete(cssString)
      styleTag.innerHTML = cssString
      appendedCss.set(updatedCssString, customStyle)
    },
  }
  appendedCss.set(cssString, customStyle)
  return customStyle
}

const getNumericCSSValue = (cssProperty: string): number => {
  return Number(cssProperty.replace('px', ''))
}

export { appendCssToDocumentHead, getNumericCSSValue }
export type { HTMLStyleElementWrapper }
